import React from 'react';
import { UIContext } from '../context/UIContext';

export const useUI = () => React.useContext(UIContext);
